package io.github.dautovicharis.charts.internal.common.model

internal data class ChartDataItem(
    val label: String,
    val item: ChartData
)
